import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`While Vue 3 dramatically clamped down on global variables, in Vue 2 you can initialize PostHog by using `}<inlineCode parentName="p">{`Object.defineProperty`}</inlineCode>{` and `}<inlineCode parentName="p">{`Vue.prototype`}</inlineCode>{`. `}</p>
    <p>{`To do this, declare it anywhere in your project: `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import posthog from "posthog-js";
Object.defineProperty(Vue.prototype, '$posthog', { value: posthog });
`}</code></pre>
    <p>{`Then, access PostHog by calling `}<inlineCode parentName="p">{`this.$posthog`}</inlineCode>{`. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//component.vue

export default {
  created() {
    this.$posthog.capture("app_created");
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      